import { render, staticRenderFns } from "./Statictics.vue?vue&type=template&id=aea76fa8&scoped=true&"
import script from "./Statictics.vue?vue&type=script&lang=js&"
export * from "./Statictics.vue?vue&type=script&lang=js&"
import style0 from "./Statictics.vue?vue&type=style&index=0&id=aea76fa8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea76fa8",
  null
  
)

export default component.exports